import React, { useCallback } from 'react';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularLinkLevel2 } from '@yme/tokens/typography';
export function AlertActionButton({ content, onClick }) {
    const onClickHandler = useCallback((event) => {
        event.preventDefault();
        if (onClick) {
            onClick();
        }
    }, [onClick]);
    return (React.createElement(RegularLinkLevel2, { color: colorCoreBlack900Base, onClick: onClickHandler, "data-testid": "product-card-learn-more-link" }, content));
}
AlertActionButton.displayName = 'AlertActionButton_Component';
